module.exports = __webpack_public_path__ + "img/DCA Web Banner.1ec97068.png";